import { Navigate, useLocation } from 'react-router';

/**
 * Redirects from old compliance monitoring paths to new assessments/oversight paths,
 * preserving any sub-path segments, query params, and hash.
 */
export const ComplianceMonitoringRedirect = () => {
  const location = useLocation();
  const newPath = location.pathname.replace(
    '/compliance/monitoring-assessments',
    '/assessments/oversight'
  );

  return <Navigate to={newPath + location.search + location.hash} replace />;
};
